import { Page } from '@/models/page-models/Page';
import { AccountsDashboard } from './AccountsDashboard';
import { ActualUse } from './ActualUse';
import { AgingReport } from './AgingReport';
import { AllNotifications } from './AllNotifications';
import { CallOff } from './CallOff';
import { ClosedQuotations } from './ClosedQuotations';
import { ClosingInventory } from './ClosingInventory';
import { CommercialGroups } from './CommercialGroups';
import { ComplaintMaster } from './ComplaintMaster';
import { ComplaintMasterByCustomer } from './ComplaintMasterByCustomer';
import { ComplaintNew } from './ComplaintNew';
import { ComplaintEdit } from './ComplaintEdit';
import { CreateCreditNote } from './CreateCreditNote';
import { CreateLoadingManifest } from './CreateLoadingManifest';
import { CreateOperator } from './CreateOperator';
import { CreatePaymentCollectionReceipt } from './CreatePaymentCollectionReceipt';
import { CreateSparePartTransfer } from './CreateSparePartTransfer';
import { CreditNoteCreditNoteId } from './CreditNoteCreditNoteId';
import { CurrencyExchange } from './CurrencyExchange';
import { Customer } from './Customer';
import { CustomerSalesComparison } from './CustomerSalesComparison';
import { CustomerSalesForecast } from './CustomerSalesForecast';
import { CustomerSalesVariance } from './CustomerSalesVariance';
import { CustomersEdit } from './CustomersEdit';
import { CustomerServiceDashboard } from './CustomerServiceDashboard';
import { CustomersNew } from './CustomersNew';
import { DailyInvoices } from './DailyInvoices';
import { DailyVatReport } from './DailyVatReport';
import { FactoryTicketCreate } from './FactoryTicketCreate';
import { FactoryTicketEdit } from './FactoryTicketEdit';
import { FgTransfer } from './FgTransfer';
import { FtDashboard } from './FtDashboard';
import { Goods } from './Goods';
import { GoodsEditor } from './GoodsEditor';
import { GoodsEditorView } from './GoodsEditorView';
import { GoodsTransferRequests } from './GoodsTransferRequests';
import { GroupSalesComparison } from './GroupSalesComparison';
import { GroupSalesVariance } from './GroupSalesVariance';
import { InvoicePaymentReceiptView } from './InvoicePaymentReceiptView';
import { InvoiceView } from './InvoiceView';
import { JournalMovements } from './JournalMovements';
import { LoadingManifestLoadingManifestId } from './LoadingManifestLoadingManifestId';
import { LoadingManifestView } from './LoadingManifestView';
import { MachineMachineId } from './MachineMachineId';
import { MachineNew } from './MachineNew';
import { Machines } from './Machines';
import { MaterialStock } from './MaterialStock';
import { MiscInvoiceCreate } from './MiscInvoiceCreate';
import { MiscInvoicesList } from './MiscInvoicesList';
import { MiscInvoiceView } from './MiscInvoiceView';
import { MiscLoadingManifest } from './MiscLoadingManifest';
import { MonthClosing } from './MonthClosing';
import { MonthlyProductStatus } from './MonthlyProductStatus';
import { MonthlyTargetByQuantity } from './MonthlyTargetByQuantity';
import { MyProductionReports } from './MyProductionReports';
import { NewSalesContract } from './NewSalesContract';
import { NewSample } from './NewSample';
import { OpenQuotations } from './OpenQuotations';
import { OperatorView } from './OperatorView';
import { OrderDetails } from './OrderDetails';
import { OrderOut } from './OrderOut';
import { PaymentCollectionReceipts } from './PaymentCollectionReceipts';
import { PoPayments } from './PoPayments';
import { PrintZebraLabel } from './PrintZebraLabel';
import { ProductionOrder } from './ProductionOrder';
import { ProductMaster } from './ProductMaster';
import { ProductMasterByCustomer } from './ProductMasterByCustomer';
import { ProductionReport } from './ProductionReport';
import { ProductionReportProductionReportId } from './ProductionReportProductionReportId';
import { ProductionReportSummary } from './ProductionReportSummary';
import { ProductsCreate } from './ProductsCreate';
import { ProductsEdit } from './ProductsEdit';
import { PurchaseOrder } from './PurchaseOrder';
import { PurchaseOrderAccounts } from './PurchaseOrderAccounts';
import { PurchaseOrderUpdateAccounts } from './PurchaseOrderUpdateAccounts';
import { PurchasingOrderAdmin } from './PurchasingOrderAdmin';
import { QualityDashboard } from './QualityDashboard';
import { QuotationMaster } from './QuotationMaster';
import { QuotationMasterByCustomer } from './QuotationMasterByCustomer';
import { QuotationView } from './QuotationView';
import { RmReceipt } from './RmReceipt';
import { RawMaterialPurchaseOrderAdd } from './RawMaterialPurchaseOrderAdd';
import { RawMaterialPurchaseOrderEdit } from './RawMaterialPurchaseOrderEdit';
import { RmTransfer } from './RmTransfer';
import { SalesCollection } from './SalesCollection';
import { SalesContractEdit } from './SalesContractEdit';
import { SalesContractMaster } from './SalesContractMaster';
import { SalesContractView } from './SalesContractView';
import { SalesDashboard } from './SalesDashboard';
import { SalesForecastMaster } from './SalesForecastMaster';
import { SalesGroups } from './SalesGroups';
import { SalesPayments } from './SalesPayments';
import { SalesReports } from './SalesReports';
import { SalesRmAlias } from './SalesRmAlias';
import { SalesTarget } from './SalesTarget';
import { SampleEdit } from './SampleEdit';
import { SampleLoadingManifest } from './SampleLoadingManifest';
import { SampleMaster } from './SampleMaster';
import { SampleMasterByCustomer } from './SampleMasterByCustomer';
import { SpareParts } from './SpareParts';
import { SparePartsCreate } from './SparePartsCreate';
import { SparePartsPurchaseOrderAdd } from './SparePartsPurchaseOrderAdd';
import { SparePartsPurchaseOrderEdit } from './SparePartsPurchaseOrderEdit';
import { SparePartsReceipt } from './SparePartsReceipt';
import { SparePartsSparePartId } from './SparePartsSparePartId';
import { SparePartsTransferRequests } from './SparePartsTransferRequests';
import { StatementOfAccount } from './StatementOfAccount';
import { StatementOfBalance } from './StatementOfBalance';
import { SupplierEdit } from './SupplierEdit';
import { SupplierNew } from './SupplierNew';
import { Suppliers } from './Suppliers';
import { TradingOrderOut } from './TradingOrderOut';
import { TransactionListing } from './TransactionListing';
import { UpdatePaymentCollection } from './UpdatePaymentCollection';
import { Users } from './Users';
import { ViewInvoice } from './ViewInvoice';
import { WipTransfer } from './WipTransfer';
import { AllOpenCustomers } from './AllOpenCustomers';

export const pageConfig: { [key:string]: Page } = {
	AccountsDashboard,
	ActualUse,
	AgingReport,
	AllNotifications,
	CallOff,
	ClosedQuotations,
	ClosingInventory,
	CommercialGroups,
	ComplaintMaster,
	ComplaintMasterByCustomer,
	ComplaintNew,
	ComplaintEdit,
	CreateCreditNote,
	CreateLoadingManifest,
	CreateOperator,
	CreatePaymentCollectionReceipt,
	CreateSparePartTransfer,
	CreditNoteCreditNoteId,
	CurrencyExchange,
	Customer,
	CustomerSalesComparison,
	CustomerSalesForecast,
	CustomerSalesVariance,
	CustomersEdit,
	CustomerServiceDashboard,
	CustomersNew,
	DailyInvoices,
	DailyVatReport,
	FactoryTicketCreate,
	FactoryTicketEdit,
	FgTransfer,
	FtDashboard,
	Goods,
	GoodsEditor,
	GoodsEditorView,
	GoodsTransferRequests,
	GroupSalesComparison,
	GroupSalesVariance,
	InvoicePaymentReceiptView,
	InvoiceView,
	JournalMovements,
	LoadingManifestLoadingManifestId,
	LoadingManifestView,
	MachineMachineId,
	MachineNew,
	Machines,
	MaterialStock,
	MiscInvoiceCreate,
	MiscInvoicesList,
	MiscInvoiceView,
	MiscLoadingManifest,
	MonthClosing,
	MonthlyProductStatus,
	MonthlyTargetByQuantity,
	MyProductionReports,
	NewSalesContract,
	NewSample,
	OpenQuotations,
	OperatorView,
	OrderDetails,
	OrderOut,
	PaymentCollectionReceipts,
	PoPayments,
	PrintZebraLabel,
	ProductionOrder,
	ProductMaster,
	ProductMasterByCustomer,
	ProductionReport,
	ProductionReportProductionReportId,
	ProductionReportSummary,
	ProductsCreate,
	ProductsEdit,
	PurchaseOrder,
	PurchaseOrderAccounts,
	PurchaseOrderUpdateAccounts,
	PurchasingOrderAdmin,
	QualityDashboard,
	QuotationMaster,
	QuotationMasterByCustomer,
	QuotationView,
	RmReceipt,
	RawMaterialPurchaseOrderAdd,
	RawMaterialPurchaseOrderEdit,
	RmTransfer,
	SalesCollection,
	SalesContractEdit,
	SalesContractMaster,
	SalesContractView,
	SalesDashboard,
	SalesForecastMaster,
	SalesGroups,
	SalesPayments,
	SalesReports,
	SalesRmAlias,
	SalesTarget,
	SampleEdit,
	SampleLoadingManifest,
	SampleMaster,
	SampleMasterByCustomer,
	SpareParts,
	SparePartsCreate,
	SparePartsPurchaseOrderAdd,
	SparePartsPurchaseOrderEdit,
	SparePartsReceipt,
	SparePartsSparePartId,
	SparePartsTransferRequests,
	StatementOfAccount,
	StatementOfBalance,
	SupplierEdit,
	SupplierNew,
	Suppliers,
	TradingOrderOut,
	TransactionListing,
	UpdatePaymentCollection,
	Users,
	ViewInvoice,
	WipTransfer,
	AllOpenCustomers
};

export const pages: Page[] = Object.values(pageConfig).sort((page1: Page, page2: Page) => {
	if(page1.routerPriority || page2.routerPriority) {
		return (page2.routerPriority || 0) - (page1.routerPriority || 0);
	}
	return 0;
});